import { SWRConfig } from 'swr';
import { getCurrentUserToken } from '../utils/cookieUtils';

// Default fetcher function with cookie-based authentication
const fetcher = async (url, options = {}) => {
  // Get current user's token efficiently
  const parsedToken = getCurrentUserToken();

  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...(parsedToken && { 'Authorization': `Bearer ${parsedToken}` }),
    },
  };

  const response = await fetch(url, { ...defaultOptions, ...options });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error('An error occurred while fetching the data.');
    error.info = errorData;
    error.status = response.status;
    throw error;
  }

  return response.json();
};

// SWR Configuration - No Caching
export const swrConfig = {
  fetcher,
  revalidateOnFocus: false,         // Always revalidate on focus
  revalidateOnReconnect: true,     // Always revalidate on reconnect
  revalidateIfStale: true,         // Always revalidate stale data
  dedupingInterval: 0,             // No deduplication - always fetch fresh
  focusThrottleInterval: 0,        // No throttling
  errorRetryCount: 0,              // No retries
  errorRetryInterval: 0,           // No retry interval
  refreshInterval: 0,              // No automatic refresh
  onError: (error, key) => {
    if (error.status === 401) {
      // Handle unauthorized access - clear cookies and redirect
      document.cookie = 'auth_token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict';
      document.cookie = 'auth_tokena=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Strict';
      window.location.href = '/login';
    }
  },
  onSuccess: (data, key) => {
    // Success handler - add any custom logic here if needed
  },
};

// SWR Provider Component
export const SWRProvider = ({ children }) => {
  return (
    <SWRConfig value={swrConfig}>
      {children}
    </SWRConfig>
  );
};

export default swrConfig;
